import { render } from "./CreateExchangeView.vue?vue&type=template&id=f7eed428"
import script from "./CreateExchangeView.vue?vue&type=script&lang=js"
export * from "./CreateExchangeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__